import {defineStore} from "pinia";

interface State {
  appLoading: boolean;
  debugMode: boolean;
  appName: string;
}
const debugMode = localStorage.getItem('debugMode');

export const useAppStore = defineStore( 'appPortalStore', {
  state: (): State => ({
    appLoading: false,
    debugMode: true,
    appName: process.env.VUE_APP_NAME || 'Checksight'
    // debugMode: debugMode !== null && isJsonString(debugMode) ? JSON.parse(debugMode) : false
  }),
  actions: {
    toggleAppLoading(isLoading: boolean) {
      this.appLoading = isLoading;
    },
  },
})